module.exports = __webpack_public_path__ + "img/show_cn_text_6.4b4ba5a8.png";